import { render, staticRenderFns } from "./bloodPressureList.vue?vue&type=template&id=2a66fb2f&scoped=true"
import script from "./bloodPressureList.vue?vue&type=script&lang=js"
export * from "./bloodPressureList.vue?vue&type=script&lang=js"
import style0 from "./bloodPressureList.vue?vue&type=style&index=0&id=2a66fb2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a66fb2f",
  null
  
)

export default component.exports